import React, { useEffect } from 'react';
import { Modal, Input, message } from 'antd';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const UpdateOrderReferenceNumber = gql`
  mutation updateOrderReferenceNumber($input: UpdateOrderReferenceNumberInput!) {
    updateOrderReferenceNumber(input: $input) {
      result
    }
  }
`;

const ReferenceModal = ({ visible, close, form, id, getLongtailBookingDetail, externalId }) => {
  const { t } = useTranslation();
  const { getFieldDecorator, setFieldsValue, setFields } = form;
  const [updateOrderReferenceNumber, { data, loading, error }] = useMutation(
    UpdateOrderReferenceNumber,
    {
      onCompleted: response => {
        if (response?.updateOrderReferenceNumber?.result) {
          close();
          getLongtailBookingDetail();
        }
      },
      onError: e => {
        if (e) {
          message.error(
            t('landlord.long_tail.booking_details.reference_modal.same_ref_number_error'),
          );
        }
      },
    },
  );
  const handleSubmit = () => {
    const { validateFields } = form;
    validateFields((errors, values) => {
      const { referenceNumber } = values;
      if (referenceNumber === '' || referenceNumber === null) {
        close();
      }
      if (!errors && referenceNumber) {
        updateOrderReferenceNumber({
          variables: {
            input: {
              externalId: referenceNumber,
              id,
            },
          },
        });
      }
    });
  };
  useEffect(() => {
    if (visible) {
      setFieldsValue({ referenceNumber: externalId ? externalId : null });
    }
  }, [visible]);
  return (
    <Modal
      centered
      visible={visible}
      onOk={handleSubmit}
      onCancel={() => {
        close();
        setFields({
          referenceNumber: {
            errors: null,
          },
        });
      }}
      okText={t('landlord.select_property.confirm')}
      cancelText={t('landlord.payment.long_tail.button.cancel')}
    >
      <p>{t('landlord.long_tail.booking_details.reference_modal.title')}</p>
      <p>{t('landlord.long_tail.booking_details.reference_modal.hint')}</p>
      <Form.Item label={t('landlord.long_tail.booking_details.reference_modal.title')}>
        {getFieldDecorator('referenceNumber', {
          rules: [
            {
              max: 250,
              message: t('landlord.long_tail.booking_details.reference_modal.max_characters_error'),
            },
            {
              pattern: /^[^\s]*$/,
              message: t('landlord.long_tail.booking_details.reference_modal.enter_space_error'),
            },
          ],
          initialValue: externalId ? externalId : null,
        })(<Input placeholder={t('landlord.long_tail.booking_details.reference_modal.title')} />)}
      </Form.Item>
    </Modal>
  );
};

export default Form.create({ name: 'reference-modal' })(ReferenceModal);
